import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { Router } from '@angular/router';
import { ConfigService } from '../config-service/config.service';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  mixpanelToken = '';
  constructor(
    private router: Router,
    private configService: ConfigService
  ) {
    // Wait for the configuration to be loaded before initializing Mixpanel
    this.configService._config_$.subscribe({
      next: (config) => {
        // Now the configuration is guaranteed to be loaded
        if (config.mixpanelToken) {
          this.mixpanelToken = config.mixpanelToken;
          mixpanel.init(config.mixpanelToken);
        }
      },
      error: (err) => {
        console.error('Failed to load configuration', err);
      },
    });
  }

  /**
   * Initialize mixpanel.
   *
   * @param userToken
   */
  init(userToken: string): void {
    mixpanel.init(this.mixpanelToken, {
      track_pageview: true,
      autotrack: true,
    });
    mixpanel.identify(userToken);
  }

  /**
   * Track a page view.
   *
   * @param route The route URL to track.
   */
  trackPageView(route: string): void {
    mixpanel.track('Page View', {
      route: route,
      eventDisplayName: { value: route },
    });
  }

  /**
   * Push a new event to Mixpanel with optional tracking information and route data.
   *
   * @param eventInfo An object containing event-related information (optional).
   * @param route The route URL to track (optional).
   */
  track(
    eventInfo?: {
      id?: string;
      eventName?: string;
      eventDisplayName?: any;
      kpi?: string;
      trigger?: string;
      eventDefinition?: string;
      propertyType?: string;
      propertyDefinition?: string;
      additionalProperties?: object;
      user_id?: string;
    },
    route?: string
  ): void {
    if (!eventInfo || !eventInfo.eventName) {
      console.error('Event name is required for tracking.');
      return;
    }

    eventInfo.user_id = localStorage.getItem('userEmail') || eventInfo.id;

    // Extract id, eventName, and eventDisplayName from eventInfo, the rest are properties
    const { eventName, ...properties }: any = eventInfo;

    // Include route as a property if provided or use the current URL
    const routeProperty = route || this.router.url;
    properties['route'] = routeProperty;

    // Track the event with Mixpanel
    mixpanel.track(eventName, {
      event: eventName,
      ...properties,
    });
  }

  register(email: string) {
    mixpanel.identify(email);
    mixpanel.people.set({
      $name: email,
      $email: email,
    });
  }

  reset() {
    mixpanel.reset();
  }

  trackBeginTime(from: string, email: string) {
    // mixpanel.identify(email);

    mixpanel.track('Quote Start time', {
      [from]: new Date().toLocaleString(),
      eventDisplayName: new Date().toLocaleString(),
    });
  }

  trackEndTime(from: string, email: string) {
    // mixpanel.identify(email);

    mixpanel.track('Quote End time', {
      [from]: new Date().toLocaleString(),
      eventDisplayName: new Date().toLocaleString(),
    });
  }
}
